import { FC } from 'react';

const DOT_KEYS = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i'];

interface Props {
  size: 'lg' | 'sm';
}

export const DotMark: FC<Props> = ({ size }) => (
  <span className={`dot-mark dot-mark-${size}`}>
    {DOT_KEYS.map(key => (
      <i key={key} />
    ))}
  </span>
);
